export default __webpack_public_path__ + "static/media/beep-02.44d80d2e.mp3";